import React, { PureComponent } from 'react';
import * as d3Scale from 'd3-scale';

import { sortByKey, isNumeric, numberFormat } from '~/core/scripts/utils';
import ProgressBar from '../ProgressBar';

class Ranking extends PureComponent {
  constructor(props) {
    super();

    const { valueKey, data, min, max, inverted = false } = props;

    this.data = data
      .filter(d => isNumeric(d[valueKey]) && !['888', '999'].includes(d.AGS))
      .sort(sortByKey(valueKey, !inverted));

    this.xScaleBar = d3Scale.scaleLinear().domain([min, max]).range([0, 100]);
  }

  renderItem(item, index) {
    const { valueKey, avg, decimals, unit } = this.props;

    return (
      <div className="ranking__item" key={`ranking__item_${valueKey}_${index}`}>
        <div className="ranking__index">{index + 1}</div>
        <div className="ranking__value">{numberFormat(item[valueKey], decimals)}&nbsp;{unit}</div>
        <div className="ranking__name">{item.Kreis}</div>
        <ProgressBar
          scale={this.xScaleBar}
          value={item[valueKey]}
          avg={avg}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="ranking">
        <div className="ranking__title">Top Kreise</div>
        <div className="ranking__list">
          {this.data.slice(0, 3).map((d, i) => this.renderItem(d, i))}
        </div>
      </div>
    );
  }
}

export default Ranking;
